import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Row, Col, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

export default function SubadminAdd() {
  const baseURL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("profileToken");
  const navigate = useNavigate();

  const initial = {
    username: "",
    password: "",
    email: "",
    fullname: "",
    mobile_no: "",
  };

  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm((p) => ({ ...p, [e.target.id]: e.target.value }));

  const handleReset = () => setForm(initial);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.username.trim() || !form.password.trim()) {
      Swal.fire("Error", "Username and Password are required", "error");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${baseURL}/subadmin/add`,
        {
          username: form.username.trim(),
          password: form.password.trim(),
          email: form.email.trim() || null,
          fullname: form.fullname.trim() || null,
          mobile_no: form.mobile_no.trim() || null,
        },
        { headers: { "x-access-token": token || "" } }
      );

      if (res.data?.status) {
        Swal.fire("Success", res.data.message || "Subadmin created", "success");
        handleReset();
        navigate("/subadmin-list");
      } else {
        Swal.fire("Error", res.data?.message || "Failed", "error");
      }
    } catch (err) {
      Swal.fire("Error", err.response?.data?.message || "Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-4">
      <h3 className="fw-bold text-center mb-4 text-success">Add Subadmin</h3>

      <form onSubmit={handleSubmit}>
        <div className="border border-success rounded-4 p-4">
          <Row className="g-4">
            <Col xs={12} md={6}>
              <label className="form-label">
                Username <span className="text-danger">*</span>
              </label>
              <input
                id="username"
                className="form-control"
                value={form.username}
                onChange={handleChange}
                placeholder="Enter username"
                required
              />
            </Col>

            <Col xs={12} md={6}>
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <input
                id="password"
                type="password"
                className="form-control"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter password"
                required
              />
            </Col>

            <Col xs={12} md={6}>
              <label className="form-label">Email (optional)</label>
              <input
                id="email"
                type="email"
                className="form-control"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email"
              />
            </Col>

            <Col xs={12} md={6}>
              <label className="form-label">Full Name (optional)</label>
              <input
                id="fullname"
                className="form-control"
                value={form.fullname}
                onChange={handleChange}
                placeholder="Enter full name"
              />
            </Col>

            <Col xs={12} md={6}>
              <label className="form-label">Mobile (optional)</label>
              <input
                id="mobile_no"
                className="form-control"
                value={form.mobile_no}
                onChange={handleChange}
                placeholder="Enter mobile"
              />
            </Col>

            <Col xs={12} md={6} className="d-flex justify-content-end gap-2 mt-4">
              <Button variant="outline-dark" className="rounded-pill px-4" type="button" onClick={handleReset}>
                Reset
              </Button>

              <Button variant="success" className="rounded-pill px-4" type="submit" disabled={loading}>
                {loading ? <Spinner size="sm" /> : "Save"}
              </Button>
            </Col>
          </Row>
        </div>
      </form>
    </div>
  );
}
